import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02a69721"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }



export default /*#__PURE__*/_defineComponent({
  __name: 'LocationOverview',
  props: ["data"],
  setup(__props) {



function returnImg(image: string) {
  return require(`@/assets/markers/${image}.svg`);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(__props.data.street), 1),
    _createElementVNode("h2", null, _toDisplayString(__props.data.city), 1),
    _createElementVNode("p", null, _toDisplayString(__props.data.country), 1),
    _createElementVNode("p", null, _toDisplayString(__props.data.property), 1)
  ]))
}
}

})